import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import apiService from '../services/apiService';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiService.getBlogPosts()
      .then(response => {
        setPosts(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching blog posts:', error);
        setLoading(false);
      });
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <Container className="mt-5">
        <div className="text-center">
          <h2>Loading...</h2>
        </div>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <h1 className="mb-4">Blog</h1>
          <p className="lead">Stay updated with our latest articles and insights.</p>
        </Col>
      </Row>
      
      <Row>
        {posts.length === 0 ? (
          <Col>
            <p>No blog posts available at the moment.</p>
          </Col>
        ) : (
          posts.map(post => (
            <Col md={6} lg={4} key={post.id} className="mb-4">
              <Card className="h-100 card-hover">
                <Card.Body className="d-flex flex-column">
                  <Card.Title>{post.title}</Card.Title>
                  <Card.Text className="flex-grow-1">
                    {post.summary}
                  </Card.Text>
                  <div className="mt-auto">
                    <small className="text-muted">
                      {formatDate(post.createdAt)}
                    </small>
                    <div className="mt-2">
                      <LinkContainer to={`/blog/${post.id}`}>
                        <Button variant="primary" size="sm">
                          Read More
                        </Button>
                      </LinkContainer>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
};

export default Blog;